export default __webpack_public_path__ + "static/mssante-logo-9582b91368b2844a5026a0875f0b3bcd.png";